import React, { useContext } from 'react'
import GlobalPopUp from '../../../utility/globalPopUp'
import { Grid, Typography } from '@mui/material';
import ConfirmationPopover from '../../../utility/confirmationPopover';
import { chatbotIntegrationAssignmentData, chatbotIntegrationAssignmentDataNew, globalIntegration, metaIntegrationFaceBookDataNew, metaIntegrationWhatsAppDataNew, metIntegrationInstagramDataNew } from '../../../../models/axiosModel';
import GlobalButton from '../../../utility/globalButton/button';
import IconsColor from '../../../utility/iconsColor';
import { ChatbotContext, ChatbotContextPayload } from '../../../../context/chatbotContext';
import FacebookInformationCard from '../../../utility/facebookInformationCard';
import { useSearchParams } from 'react-router-dom';
import integrationStyles from '../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss'
import globalStyles from "../../../../assets/styles/global.module.scss";
import popupStyles from "../../../../assets/styles/componentStyles/globalPopupStyles.module.scss";
import { primaryColor } from '../../../../utils/colors';

interface addChatbotIntegrationDetailsInterface {
    // meta_integration_id: string,
    chatbot_id: string,
    integrated_channel_id: string
    // instagram_id: string,
    // page_id: string,
    // meta_integration_type_id: string
}

interface ShowAvailableInstagramProps {
    flagShowAvailableNumbers: boolean,
    setFlagShowAvailableNumbers: React.Dispatch<React.SetStateAction<boolean>>;
    smallScreen: boolean,
    showConfirmationPopover: boolean,
    confirmationPopoverAnchorEl: null | HTMLButtonElement,
    handleCloseConfirmationPopover: () => void,
    addChatbotIntegrationDetails: addChatbotIntegrationDetailsInterface,
    AddChatbotIntegration: (addChatbotIntegrationDetails: addChatbotIntegrationDetailsInterface) => void;
    // availablePhoneNumberData: globalIntegration[],
    availablePhoneNumberData: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[],
    handleRemoveChatbotIntegration: (display_page_name: string, integrated_channel_id: string) => void,
    displayPhoneNumber: string,
    launchWhatsAppSignup: () => void
    saveChatbotIntegrationData: (integrated_channel_id: string, display_page_name: string, event?: React.MouseEvent<HTMLButtonElement>) => void
}

function ShowAvailableInstagramPages(props: ShowAvailableInstagramProps) {
    const { chatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload;
    const [searchParams, setSearchParams] = useSearchParams()
    const { flagShowAvailableNumbers, setFlagShowAvailableNumbers, smallScreen, showConfirmationPopover, confirmationPopoverAnchorEl, handleCloseConfirmationPopover, addChatbotIntegrationDetails, AddChatbotIntegration, availablePhoneNumberData, handleRemoveChatbotIntegration, launchWhatsAppSignup, displayPhoneNumber, saveChatbotIntegrationData } = props
    return (
        <div>
            <GlobalPopUp
                open={flagShowAvailableNumbers}
                handleClose={() => { setFlagShowAvailableNumbers(false) }}
                flagShowCloseIcon
                paperMinWidth={smallScreen ? '85%' : '90vw'}
                titlePadding='0px'
                height='90vh'
                overflow='hidden'
            >
                <Grid container direction={"column"} flexWrap={"nowrap"} className={integrationStyles.integrationPopupContainer} mt={{ xs: 1, lg: 0 }}>

                    <Grid item className={`${globalStyles.textCenter} ${integrationStyles.integrationPopupTitle}`}>
                        <Typography className={popupStyles.popupTitleTypography} marginBlock={'5px'}>
                            Add Instagram Pages
                        </Typography>
                    </Grid>

                    <Grid item className={integrationStyles.intergationPopupBody}>
                        <Grid container direction={"column"} flexWrap={"nowrap"} className={integrationStyles.metaIntegrationPopupContainer}>
                            <Grid item>
                                <Grid container gap="15px">
                                    <ConfirmationPopover
                                        open={showConfirmationPopover}
                                        anchorEl={confirmationPopoverAnchorEl}
                                        handleClose={handleCloseConfirmationPopover}
                                        onConfirmation={() => { AddChatbotIntegration(addChatbotIntegrationDetails) }}
                                        descriptionText={<p>Are you sure you want to deploy <span style={{ fontWeight: "600" }}>{chatBotDetails?.chatbot_name}</span> on <span style={{ fontWeight: "600" }}>{displayPhoneNumber}</span> ?</p>}
                                    />
                                    {availablePhoneNumberData.filter((data: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) => data.channel_name === "Instagram").length > 0 && availablePhoneNumberData.filter((data: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) => data.channel_name === "Instagram").map((integrationData, index) => (
                                        <Grid container key={index} direction={"column"} gap="15px" sx={{ width: "auto" }}>
                                            <Grid item>
                                                <Grid container gap="15px">
                                                    <FacebookInformationCard
                                                        integrationType='Instagram'
                                                        key={index}
                                                        flagShowLinkedChatbot
                                                        flagDelete={false}
                                                        title={`WhatsApp Account ${index + 1}`}
                                                        currentlySelected={"chatbot_integration_assignment_data" in integrationData && integrationData.chatbot_integration_assignment_data.some((chatbot: chatbotIntegrationAssignmentDataNew) => (chatbot?.chatbot_id ?? chatbot?.ai_chatbot_id)?.toString() == searchParams.get('chatbot_id')) || false}
                                                        showRemoveChatbotIntegration={false}
                                                        disabled={("chatbot_integration_assignment_data" in integrationData && integrationData?.chatbot_integration_assignment_data && integrationData?.chatbot_integration_assignment_data.length > 0) ? true : false}
                                                        removeChatbotIntegration={() => {
                                                            handleRemoveChatbotIntegration(
                                                                "instagram_account_name" in integrationData ? integrationData.instagram_account_name : "",
                                                                String(integrationData.integrated_channel_id) || "",
                                                            )
                                                        }}
                                                        addChatbotIntegration={("chatbot_integration_assignment_data" in integrationData && integrationData?.chatbot_integration_assignment_data.length == 0) ? (instagram_id: any, event: any) => {
                                                            if (event) {
                                                                saveChatbotIntegrationData(integrationData.integrated_channel_id.toString(), "instagram_account_name" in integrationData ? integrationData.instagram_account_name : "", event)
                                                            } else {
                                                                saveChatbotIntegrationData(integrationData.integrated_channel_id.toString(), "instagram_account_name" in integrationData ? integrationData.instagram_account_name : "")
                                                            }
                                                        } : undefined}
                                                        details={{
                                                            page_id: "instagram_account_id" in integrationData ? integrationData.instagram_account_id : "",
                                                            integrated_channel_id: String(integrationData.integrated_channel_id) || "",
                                                            page_name: "instagram_account_name" in integrationData ? integrationData.instagram_account_name : "",
                                                            page_category: "instagram_account_category" in integrationData ? integrationData.instagram_account_category : "",
                                                            linked_chatbots: "chatbot_integration_assignment_data" in integrationData ? integrationData.chatbot_integration_assignment_data : undefined,
                                                        }}
                                                        flagIntegration={true}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                            <Grid item>
                                <GlobalButton
                                    buttonText="Instagram Account"
                                    onClick={launchWhatsAppSignup}
                                    className='borderedButtonStyle'
                                    sx={{ padding: '8px 16px !important' }}
                                    startIcon={<IconsColor fillColor={primaryColor} iconName="plus" width="16px" height="16px" />}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>
            </GlobalPopUp>
        </div>
    )
}

export default ShowAvailableInstagramPages